import React from 'react';

import { Container, makeStyles, Typography, Box } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { i18n } from '../../translate/i18n';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: '100vh',
		backgroundColor: theme.palette.type === 'dark' ? '#151515' : '#f8fafc',
		padding: theme.spacing(3),
	},
	main: {
		textAlign: 'center',
		maxWidth: 420,
	},
	iconWrap: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 80,
		height: 80,
		borderRadius: '50%',
		backgroundColor: 'rgba(239, 68, 68, 0.12)',
		color: '#dc2626',
		margin: '0 auto',
		marginBottom: theme.spacing(2),
	},
	icon: {
		fontSize: 48,
	},
	errorBox: {
		marginTop: theme.spacing(2),
		padding: theme.spacing(2),
		borderRadius: 8,
		backgroundColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)',
		textAlign: 'left',
		overflow: 'auto',
	},
	errorPre: {
		margin: 0,
		fontSize: 13,
		color: theme.palette.type === 'dark' ? '#fca5a5' : '#b91c1c',
		wordBreak: 'break-word',
	},
}));

function ErrorFallback({ error }) {
	const classes = useStyles();

	return (
		<div className={classes.root} role="alert">
			<Container component="main" className={classes.main} maxWidth="sm">
				<div className={classes.iconWrap}>
					<ErrorOutlineIcon className={classes.icon} />
				</div>
				<Typography variant="h5" component="h1" gutterBottom style={{ fontWeight: 600 }}>
					{i18n.t('errorFallback.error')}
				</Typography>
				<Typography variant="body1" color="textSecondary" style={{ marginBottom: 8 }}>
					{i18n.t('errorFallback.instructions')}
				</Typography>
				{error?.message && (
					<Box className={classes.errorBox}>
						<Typography variant="caption" color="textSecondary" display="block" gutterBottom>
							{i18n.t('errorFallback.detail')}:
						</Typography>
						<pre className={classes.errorPre}>{error.message}</pre>
					</Box>
				)}
			</Container>
		</div>
	);
}

export default ErrorFallback;
